import Tag from './Tag';

export { Tag };



// WEBPACK FOOTER //
// src/modules/screens/settings/Tag/components/index.js